import CommonMsg from "@com/loading/CommonMsg";
import Const from '@const/index';
import Path from "../router/path";
import axios from 'axios';
import {
  rememberPath
} from './auth';

/******************************************/
/************** 封装axios请求 **************/
/******************************************/
// 请求超时
axios.defaults.timeout = 30000;
axios.defaults.baseURL = Const.BASE_API;
// axios.defaults.withCredentials = true; // cookie跨域

// request拦截器
axios.interceptors.request.use(
  config => {
    let { data, url } = config;
    config.data = data = JSON.parse(JSON.stringify(data));
    config.withCredentials = true; // 携带跨域cookie

    if (data) {
      const { urlJoin } = data;

      if (urlJoin) {
        config.url = url + urlJoin;
        delete data.urlJoin;
      }
      // GET请求
      if (config.method === "get") {
        Object.keys(data).map(key => {
          if (Array.isArray(data[key])) data[key] = data[key].join(',');
          if (data[key] === "") delete data[key];
        });
        config.params = data;
      } else {
        config.data = data;
      }
    }

    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    CommonMsg.error(error.message);
    Promise.reject(error);
  }
);

// response 拦截器
axios.interceptors.response.use(
  response => Promise.resolve(response),
  error => Promise.reject(error)
);

// 白名单，虽然是错误码，但是这里不处理，后续处理
const whiteList = {
  [Const.HTTP_CODE.NEED_AUTH]: "授权已过期，请联系管理员!",
};
export default (config, success, error) => {
  const { baseURL, url, method = 'post', data = {}, headers = {}, params } = config;
  return axios({
    baseURL,
    url,
    method,
    data,
    headers,
    params,
  }).then(
    response => {
      const { message: msg, status, data, result, successResponse } = response.data;

      if (status === Const.HTTP_CODE.NEED_LOGIN) {
        console.log('重新登录', status);
        rememberPath();
        window.location.href = Path.LOGIN;
      } else if (successResponse) { // 导播台请求成功
        const res = response.data;
        typeof success === 'function' && success(res);
        return Promise.resolve(res);
      } else if (status !== Const.HTTP_CODE.SUCCESS) {
        if (status in whiteList) { // 白名单 处理
          CommonMsg.error(whiteList[status] || '操作失败');
          typeof error === 'function' && error(whiteList[status]);
          return Promise.reject(whiteList[status]);
        }
        // 过滤硬件接口中get方式的报错，不在页面提示错误
        if (/^device\/remote\/get.+/.test(url)) return Promise.reject(msg);
        CommonMsg.error(msg || '操作失败');
        typeof error === 'function' && error(msg);
        return Promise.reject(msg);
      } else {
        const res = data || result || '';
        typeof success === 'function' && success(res || response.data);
        return Promise.resolve(res);
      }
    },
    error => {
      console.log('err: ' + error); // for debug
      // 过滤硬件接口中get方式的报错，不在页面提示错误
      if (/^device\/remote\/get.+/.test(url)) return Promise.reject(error);
      CommonMsg.error(error.message);
      return Promise.reject(error);
    }
  );
};
